export default "__VITE_ASSET__BIwb3Qsa__"